import React, { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { FaDownload, FaTimes, FaQrcode } from "react-icons/fa";
import "../css/Qrcodemodal.css";

const QRCodeModal = ({ isOpen, onClose, restaurante }) => {
  const qrRef = useRef(null);

  if (!isOpen || !restaurante) return null;

  // Gera a URL de avaliação do restaurante
  const baseUrl = window.location.origin;
  const avaliacaoUrl = `${baseUrl}/restaurantes/${restaurante.id}/avaliar`;

  // Função para baixar o QR Code como imagem
  const handleDownload = () => {
    const svg = qrRef.current.querySelector("svg");
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);

      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = `qrcode-avaliacao-${restaurante.nome.replace(/\s+/g, "-").toLowerCase()}.png`;
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
  };

  // Função para copiar link
  const handleCopyLink = () => {
    navigator.clipboard.writeText(avaliacaoUrl);
    alert("Link copiado para a área de transferência!");
  };

  return (
    <div className="qrcode-modal-overlay" onClick={onClose}>
      <div className="qrcode-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Botão fechar */}
        <button className="qrcode-modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Header */}
        <div className="qrcode-modal-header">
          <div className="qrcode-modal-icon">
            <FaQrcode />
          </div>
          <h2>QR Code de Avaliação</h2>
          <p className="qrcode-modal-subtitle">{restaurante.nome}</p>
        </div>

        {/* QR Code */}
        <div className="qrcode-container" ref={qrRef}>
          <QRCodeSVG
            value={avaliacaoUrl}
            size={200}
            level="H"
            includeMargin={true}
            bgColor="#ffffff"
            fgColor="#000000"
          />
        </div>

        {/* Instruções */}
        <p className="qrcode-instrucao">
          Escaneie o QR Code para avaliar o restaurante
        </p>

        {/* Link */}
        <div className="qrcode-link-container">
          <input
            type="text"
            value={avaliacaoUrl}
            readOnly
            className="qrcode-link-input"
          />
          <button className="qrcode-link-copy" onClick={handleCopyLink}>
            Copiar
          </button>
        </div>

        {/* Botões */}
        <div className="qrcode-modal-actions">
          <button className="qrcode-btn secondary" onClick={onClose}>
            Fechar
          </button>
          <button className="qrcode-btn primary" onClick={handleDownload}>
            <FaDownload /> Baixar QR Code
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal;